import { createFeatureSelector, createSelector } from '@ngrx/store';

import { featureKey, State } from '../reducers/auth.reducer';
import {BusinessTypeEnum} from '../../enums/BusinessTypeEnum';

const getActiveBusinessHelper = ({ user }) => {
  if (!user) {
    return null;
  }

  let businessId;
  const businessType = user.typeBusiness || 'company';

  switch (businessType) {
    case BusinessTypeEnum.Establishment:
      businessId = user.establishmentId;
      return user.establishments.find(establishment => establishment.id === businessId);
    case BusinessTypeEnum.Company:
      businessId = user.companyId;
      return user.companies.find(company => company.id === businessId);
    default:
      return null;
  }
};

const getActiveBusinessIDHelper = ({ user }) => {
  if (!user) {
    return null;
  }

  const businessType = user.typeBusiness || 'company';

  switch (businessType) {
    case BusinessTypeEnum.Establishment:
      return user.establishmentId;
    case BusinessTypeEnum.Company:
      return user.companyId;
    default:
      return null;
  }
};


export const selectFeatureState = createFeatureSelector<State>(featureKey);

export const getToken = createSelector(selectFeatureState, (state): string => state && state.token);
export const isLogged = createSelector(selectFeatureState, ({ token }): boolean => !!token);
export const getUser = createSelector(selectFeatureState, (state): any => state && state.user);
export const userIsLoading = createSelector(selectFeatureState, ({ loading }): boolean => loading);
export const getAccounts = createSelector(getUser, ({ companies, establishments }): any => [...companies, ...establishments]);
export const getActiveBusiness = createSelector(selectFeatureState, (state): any => state && getActiveBusinessHelper(state));
export const getActiveBusinessId = createSelector(selectFeatureState, (state): string => state && getActiveBusinessIDHelper(state));
export const getAccountType = createSelector(getUser, (user): any => user && user.typeBusiness);
export const isOnboardCompleted = createSelector(getUser, (user): boolean => user && !!user.is_onboarding_complete);
export const isCompanyType = createSelector(getAccountType, (typeBusiness): boolean => typeBusiness === BusinessTypeEnum.Company);
export const isEstablishmentType = createSelector(getAccountType, (typeBusiness): boolean =>
  typeBusiness === BusinessTypeEnum.Establishment);
